import { Grid, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { AnswersProps } from "../../app/models/Answers";

const HowYoungChildrenLearn: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const defaultValues = {
    learn: answersData.find((answer) => answer.systemCodeId === 259)?.answer,
  };
  useForm({
    defaultValues,
  });

  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={12}>
        <Typography fontWeight={700} mb={2}>
          How Young Children Learn
        </Typography>
        <Typography>How do you believe young children learn? </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="learn"
          placeholder="I believe young children learn:"
          inputProps={{ maxLength: 500 }}
          fullWidth
          required
          multiline
          rows={2}
          value={
            answersData.find((answer) => answer.systemCodeId === 259)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 259;
            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
        />
        <Typography fontSize={13}>{defaultValues.learn?.length}/500</Typography>
      </Grid>
    </Grid>
  );
};
export default HowYoungChildrenLearn;
